import { useState, DragEvent, useRef, ChangeEvent } from "react";

interface IUseFileDropzoneProps {
    onFilesChange: (files: File[]) => void;
}

type TUseFileDropzone = (props: IUseFileDropzoneProps) => {
    inputRef: React.MutableRefObject<HTMLInputElement | null>;
    isDragActive: boolean;
    handleDragEnter: (event: DragEvent<HTMLDivElement>) => void;
    handleDragOver: (event: DragEvent<HTMLDivElement>) => void;
    handleDragLeave: (event: DragEvent<HTMLDivElement>) => void;
    handleDrop: (event: DragEvent<HTMLDivElement>) => void;
    handleInputChange: (event: ChangeEvent<HTMLInputElement>) => void;
    handleClick: () => void;
};

export const useFileDropzone: TUseFileDropzone = ({
    onFilesChange,
}) => {
    // Ref на скрытый input[type="file"]
    const inputRef = useRef<HTMLInputElement | null>(null);

    // Состояние активности drag над зоной
    const [isDragActive, setIsDragActive] =
        useState<boolean>(false);

    // Обработчик клика по зоне
    const handleClick = () => {
        inputRef.current?.click();
    };

    // Обработчик drag enter
    const handleDragEnter = (
        event: DragEvent<HTMLDivElement>,
    ) => {
        event.preventDefault();
        setIsDragActive(true);
    };

    // Обработчик drag over
    const handleDragOver = (
        event: DragEvent<HTMLDivElement>,
    ) => {
        event.preventDefault();
    };

    // Обработчик drag leave
    const handleDragLeave = (
        event: DragEvent<HTMLDivElement>,
    ) => {
        event.preventDefault();
        setIsDragActive(false);
    };

    // Универсальная обработка файлов
    const processFiles = (files: File[]) => {
        if (files.length === 0) {
            return;
        }

        // Передаём файлы наружу
        onFilesChange(files);
    };

    // Обработчик drop
    const handleDrop = (
        event: DragEvent<HTMLDivElement>,
    ) => {
        event.preventDefault();
        setIsDragActive(false);

        const droppedFiles = Array.from(
            event.dataTransfer.files,
        );

        processFiles(droppedFiles);
    };

    // Обработчик выбора файлов через input
    const handleInputChange = (
        event: ChangeEvent<HTMLInputElement>,
    ) => {
        if (!event.target.files) {
            return;
        }

        const selectedFiles = Array.from(
            event.target.files,
        );

        processFiles(selectedFiles);

        // Сбрасываем input, чтобы можно было выбрать тот же файл повторно
        if (inputRef.current) {
            inputRef.current.value = "";
        }
    };

    return {
        inputRef,
        isDragActive,
        handleDragEnter,
        handleDragOver,
        handleDragLeave,
        handleDrop,
        handleInputChange,
        handleClick,
    };
};
